import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * UX gate only — the API's SuperadminGuard is the real boundary. Runs after
 * authGuard in the route's canActivate chain, so the user is known to be
 * authenticated; this just keeps non-admins from seeing a broken shell.
 */
export const adminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.whenReady();

  if (authService.user()?.role === 'SUPERADMIN') {
    return true;
  }

  return router.parseUrl('/dashboard');
};
